import React from 'react'
import '../scss/ResultadoDetailMenu.css'
import IconTiempo from '../icons/IconTiempo'
import IconPodium from '../icons/IconPodium'
import IconDonut from '../icons/IconDonut'
import IconMap from '../icons/IconMap'
import IconNotificarOn from '../icons/IconNotificarOn'
import IconCrown from '../icons/IconCrown'
/*
import ResultadoDetailTablaPasos from './ResultadoDetailTablaPasos'
import ResultadoDetailTablaPuestos from './ResultadoDetailTablaPuestos'
*/

const ResultadoDetailMenu = (props) => {
  const botonSeleccionado = props.botonSeleccionado
  const onSelectBoton = props.onSelectBoton

  return <ul className={'resultado-menu'}>
    <li className={'resultado-menu__item ' + (botonSeleccionado === 1 ? 'resultado-menu__item--active' : '')}
      onClick={() => { onSelectBoton(1) }}>
      <IconTiempo />
      <label className={'resultado-menu__label'}>
        PASOS
      </label>
    </li>
    <li className={'resultado-menu__item ' + (botonSeleccionado === 2 ? 'resultado-menu__item--active' : '')}
      onClick={() => { onSelectBoton(2) }}>
      <IconPodium />
      <label className={'resultado-menu__label'}>
        PUESTOS
      </label>
    </li>
    {props.tieneRankings && (
      <li className={'resultado-menu__item ' + (botonSeleccionado === 3 ? 'resultado-menu__item--active' : '')}
        onClick={() => { onSelectBoton(3) }}>
        <IconCrown />
        <label className={'resultado-menu__label'}>
          RANKINGS
        </label>
      </li>
    )}
    {props.isSectores ? (
      <li className={'resultado-menu__item ' + (botonSeleccionado === 4 ? 'resultado-menu__item--active' : '')}
        onClick={() => { onSelectBoton(4) }}>
        <IconDonut />
        <label className={'resultado-menu__label'}>
          SECTORES
        </label>
      </li>
    ) : (
      <li className={'resultado-menu__item resultado-menu__item--invisible'} />
    )}
    {props.isMapa ? (
      <li className={'resultado-menu__item ' + (botonSeleccionado === 5 ? 'resultado-menu__item--active' : '')}
        onClick={() => { onSelectBoton(5) }}>
        <IconMap />
        <label className={'resultado-menu__label'}>
          MAPA
        </label>
      </li>
    ) : (
      <li className={'resultado-menu__item resultado-menu__item--invisible'} />
    )}
    {props.isNotificaciones ? (
      <li className={'resultado-menu__item ' + (botonSeleccionado === 6 ? 'resultado-menu__item--active' : '')}
        onClick={() => { onSelectBoton(6) }}>
        <IconNotificarOn fill={'white'} />
        <label className={'resultado-menu__label'}>
          NOTIFICAC.
        </label>
      </li>
    ) : (
      <li className={'resultado-menu__item resultado-menu__item--invisible'} />
    )}
  </ul>
}

export default ResultadoDetailMenu



// WEBPACK FOOTER //
// ./src/components/ResultadoDetailMenu.js